import type { DeveloperPanelState } from './types'

const state = (): DeveloperPanelState => ({
  emulators: []
})

export default state
